import { PhoneConfirmationModalComponent, TYPE_SUBMIT_FORM } from 'Pages/registratorCabinet'

export enum STEP_FORM {
	DATA = 'data',
	COMPANY = 'company',
	DOCUMENT_LOAD = 'document_load',
	PAY_PRODUCT = 'pay_product',
	IDENTIFICATION = 'identification',
	DOCUMENT_FNS = 'document_fns',
}

export enum RbidosRequestStatuses {
	S_NEW = 's_new',
	S_CREATED = 's_created',
	S_REGISTERED = 's_registered',
	S_CBOL_WAITING = 's_cbol_waiting',
	S_CBOL_CODE_ACCEPTED = 's_cbol_code_accepted',
	S_CBOL_PASSED = 's_cbol_passed',
	S_REQUEST_CREATED = 's_request_created',
	S_PUSH_DOCS_ACCEPTED = 's_push_docs_accepted',
	S_COMPANY_SENT = 's_company_sent',
	S_DOCS_SENT = 's_docs_sent',
	S_DOCS_GENERATED = 's_docs_generated',
	S_DOCS_LOADED = 's_docs_loaded',
	S_DIVISION_SENT = 's_division_sent',
	S_TARIFF_SENT = 's_tariff_sent',
	S_EXECUTION = 's_execution',
	S_CI_WAIT_PKCS10 = 's_ci_wait_pkcs10',
	S_CI_WAIT_CONSUMER_IDENTIFICATION = 's_ci_wait_consumer_identification',
	S_CI_CERTIFICATE_ISSUE = 's_ci_certificate_issue',
	S_CI_WAIT_CERTIFICATE_RECEIVE = 's_ci_wait_certificate_receive',
	S_CI_COMPLETE = 's_ci_complete',
	S_CI_REJECTED = 's_ci_rejected',
	S_CI_ERROR = 's_ci_error',
	S_CI_CANCELED = 's_ci_canceled',
	S_CI_WAIT_SCAN_UPLOAD = 's_ci_wait_scan_upload',
	S_RBIDOS_OPEN_ACCOUNT_REJECTED = 's_rbidos_open_account_rejected',
	S_RBIDOS_FNS_REGISTRATION_COMPLETED_NO_DOS = 's_rbidos_fns_registration_completed_no_dos',
	S_RBIDOS_ACCOUNT_OPENED = 's_rbidos_account_opened',
	S_RBIDOS_CANCELED_NO_FNS = 's_rbidos_canceled_no_fns',
	S_RBIDOS_FNS_PACKAGE_SEND = 's_rbidos_fns_package_send',
	S_RBIDOS_FNS_REGISTRATION_REJECTED = 's_rbidos_fns_registration_rejected',
	S_RBIDOS_GOT_FNS_RESULT = 's_rbidos_got_fns_result',
	S_RBIDOS_KEP_UL_REQUESTED = 's_rbidos_kep_ul_requested',
	S_RBIDOS_FNS_RECEIPT_RECEIVED = 's_rbidos_fns_receipt_received',
	S_RBIDOS_COMPLIANCE_UL_CHECK_FAIL = 's_rbidos_compliance_ul_check_fail',
	S_RBIDOS_DOS_DOC_SIGN_REQUESTED = 's_rbidos_dos_doc_sign_requested',
	S_RBIDOS_VSP_NO_DOS_ACCOUNT_OPENED = 's_rbidos_vsp_no_dos_account_opened',
	S_RBIDOS_CA_VALIDATION_COMPLETE = 's_rbidos_ca_validation_complete',
	S_RBIDOS_CA_VALIDATION_REJECTED = 's_rbidos_ca_validation_rejected',
	S_RBIDOS_KEP_UL_ERROR = 's_rbidos_kep_ul_error',
	S_RBIDOS_ORGANIZATION_IDENTIFICATION_ERROR = 's_rbidos_organization_identification_error',
	S_RBIDOS_ORGANIZATION_IDENTIFICATION_REJECTED = 's_rbidos_organization_identification_rejected',
	S_KEP_UL_KORUS_REQUEST_CREATED_SUCCESS = 's_kep_ul_korus_request_created_success',
	S_KEP_UL_KORUS_REQUEST_CREATION_ERROR = 's_kep_ul_korus_request_creation_error',
	S_KEP_UL_WORKFLOW_SUCCESS_CREATED = 's_kep_ul_workflow_success_created',
	S_KEP_UL_WORKFLOW_ERROR_CREATE = 's_kep_ul_workflow_error_create',
	S_KEP_UL_STATEMENT_RECEIVED_SUCCESS = 's_kep_ul_statement_received_success',
	S_KEP_UL_REQUEST_SENT_TO_VERIFICATION_SUCCESS = 's_kep_ul_request_sent_to_verification_success',
	S_KEP_UL_REQUEST_ERROR_SEND_TO_VERIFICATION = 's_kep_ul_request_error_send_to_verification',
	S_KEP_UL_APPROVED = 's_kep_ul_approved',
	S_KEP_UL_REQUEST_REJECTED_BY_OPERATOR = 's_kep_ul_request_rejected_by_operator',
	S_KEP_UL_REQUEST_ERROR_GENERATION_CERTIFICATE = 's_kep_ul_request_error_generation_certificate',
	S_KEP_UL_REQUEST_UNEXPECTED_ERROR = 's_kep_ul_request_unexpected_error',
	S_KEP_UL_DOCUMENTS_SIGNED_SUCCESS = 's_kep_ul_documents_signed_success',
	S_KEP_UL_DOCUMENTS_SIGNING_ERROR = 's_kep_ul_documents_signing_error',
	S_KEP_UL_SIGNS_SENT_SUCCESS = 's_kep_ul_signs_sent_success',
	S_KEP_UL_SIGNS_SENDING_ERROR = 's_kep_ul_signs_sending_error',
	S_KEP_UL_REQUEST_PEM_SENT_SUCCESS = 's_kep_ul_request_pem_sent_success',
	S_KEP_UL_REQUEST_ERROR_SENDING_PEM = 's_kep_ul_request_error_sending_pem',
	S_RBIDOS_RESERVE_ACCOUNT_COMPLETED = 's_rbidos_reserve_account_completed',
	S_RBIDOS_RESERVE_ACCOUNT_REJECTED = 's_rbidos_reserve_account_rejected',
	S_DELETED = 's_deleted',
	S_RBIDOS_PEP_DOS_DOC_GENERATION_ERROR = 's_rbidos_pep_dos_doc_generation_error',
	S_RBIDOS_PEP_DOS_DOC_SIGN_REQUEST_ACCEPTED = 's_rbidos_pep_dos_doc_sign_request_accepted',
	S_RBIDOS_PEP_DOS_DOC_SIGN_REQUESTED = 's_rbidos_pep_dos_doc_sign_requested',
	S_RBIDOS_PEP_DOS_DOC_SIGNED = 's_rbidos_pep_dos_doc_signed',
	S_RBIDOS_PEP_OPEN_ACCOUNT_ERROR = 's_rbidos_pep_open_account_error',
	S_SBOL_VERIFICATION_FAILED = 's_cbol_verification_failed',
}

export const STATUS_RBIDOS_REQUEST = {
	[RbidosRequestStatuses.S_NEW]: {
		slug: RbidosRequestStatuses.S_NEW,
		name: 'Новая заявка',
		description: `Вы можете заполнять данные во всех открытых вкладках (шагах) заявки. 
		Для проверки e-mail необходимо полностью заполнить шаг 
		"Данные клиента" и нажать кнопку "Проверить e-mail"`,
		isShowModalForPush: false,
		buttons: {
			push: true,
			typePush: TYPE_SUBMIT_FORM.PUSH,
			stepAfterPush: STEP_FORM.DATA,
			titlePush: 'Проверить e-mail',
			rollback: false,
			save: true,
		},
	},
	[RbidosRequestStatuses.S_CREATED]: {
		slug: RbidosRequestStatuses.S_CREATED,
		name: 'Ожидание подтверждения e-mail',
		description: `Вы можете заполнять данные во всех открытых вкладках (шагах) заявки. 
		Мы отправили письмо со ссылкой подтверждения на указанный в заявке адрес электронной почты. 
		Попросите клиента перейти по ссылке.`,
		isShowModalForPush: false,
		buttons: {
			typePush: TYPE_SUBMIT_FORM.UPDATE,
			stepAfterPush: STEP_FORM.DATA,
			titlePush: 'Обновить',
			pushIcon: 'refresh',
			rollback: true,
			save: true,
			push: true,
			timer: true,
		},
	},
	[RbidosRequestStatuses.S_REGISTERED]: {
		slug: RbidosRequestStatuses.S_REGISTERED,
		name: 'Подтвержден e-mail',
		description: `Теперь клиенту необходимо пройти проверку в Сбербанк Онлайн - убедитесь,
		 что номер телефона и другие сведения указаны верно`,
		buttons: {
			push: true,
			typePush: TYPE_SUBMIT_FORM.PUSH,
			stepAfterPush: STEP_FORM.DATA,
			titlePush: 'Подтвердить Сбербанк Онлайн',
			rollback: false,
			save: true,
		},
	},
	[RbidosRequestStatuses.S_CBOL_WAITING]: {
		slug: RbidosRequestStatuses.S_CBOL_WAITING,
		name: 'Ожидание подтверждения СБОЛ',
		description: `Клиенту отправлена смс со ссылкой на дополнительную информацию. Ему необходимо пройти по ссылке 
		в смс, ознакомиться с информацией, указать Сбер ID на странице Сбербанк Онлайн и сообщить Вам полученный код. 
		Укажите данный код в соответствующем поле и нажмите кнопку "Подтвердить номер".`,
		isShowModalForPush: true,
		modalComponentNameForPush: PhoneConfirmationModalComponent,
		buttons: {
			push: true,
			typePush: TYPE_SUBMIT_FORM.SEND_CODE_EMAIL_OR_PHONE,
			stepAfterPush: STEP_FORM.DATA,
			titlePush: 'Подтвердить номер',
			rollback: true,
			save: true,
			update: true,
		},
	},
	[RbidosRequestStatuses.S_CBOL_CODE_ACCEPTED]: {
		slug: RbidosRequestStatuses.S_CBOL_CODE_ACCEPTED,
		name: 'Ожидание подтверждения',
		description: `В настоящее время осуществляются дополнительные проверки. Пожалуйста, подождите. 
		Для проверки готовности нажмите "Обновить"`,
		buttons: {
			push: true,
			typePush: TYPE_SUBMIT_FORM.UPDATE,
			stepAfterPush: STEP_FORM.DATA,
			titlePush: 'Обновить',
			pushIcon: 'refresh',
			rollback: true,
			save: true,
		},
	},
	[RbidosRequestStatuses.S_CBOL_PASSED]: {
		slug: RbidosRequestStatuses.S_CBOL_PASSED,
		name: 'Верификация СБОЛ пройдена',
		description: `Мы поможем сформировать документы для регистрации бизнеса. Для этого Вам необходимо заполнить 
		данные на шаге "Сведения об организации" и загрузить документы. Затем нажмите кнопку "Подготовить документы"`,
		buttons: {
			push: false,
			rollback: false,
			save: false,
		},
	},
	[RbidosRequestStatuses.S_REQUEST_CREATED]: {
		slug: RbidosRequestStatuses.S_REQUEST_CREATED,
		name: 'Заполнение документов',
		description: `Мы поможем сформировать документы для регистрации бизнеса. 
		Для этого необходимо заполнить данные на шаге "Сведения об организации" 
		и загрузить документы.
		Затем нажмите кнопку "Подготовить документы"`,
		isShowModalForPush: false,
		buttons: {
			push: true,
			typePush: TYPE_SUBMIT_FORM.PUSH,
			titlePush: 'Подготовить документы',
			stepAfterPush: STEP_FORM.DOCUMENT_LOAD,
			rollback: true,
			save: true,
		},
	},
	[RbidosRequestStatuses.S_PUSH_DOCS_ACCEPTED]: {
		slug: RbidosRequestStatuses.S_PUSH_DOCS_ACCEPTED,
		name: 'Подготовка документов',
		description: `В настоящее время подготавливаются документы для регистрации бизнеса клиента. 
		Для проверки готовности нажмите "Обновить"`,
		isShowModalForPush: false,
		buttons: {
			push: true,
			typePush: TYPE_SUBMIT_FORM.UPDATE,
			titlePush: 'Обновить',
			pushIcon: 'refresh',
			rollback: true,
			save: true,
		},
	},
	[RbidosRequestStatuses.S_COMPANY_SENT]: {
		slug: RbidosRequestStatuses.S_COMPANY_SENT,
		name: 'Подготовка документов',
		description: `В настоящее время подготавливаются документы для регистрации бизнеса клиента. 
		Для проверки готовности нажмите "Обновить"`,
		isShowModalForPush: false,
		buttons: {
			push: true,
			typePush: TYPE_SUBMIT_FORM.UPDATE,
			titlePush: 'Обновить',
			pushIcon: 'refresh',
			rollback: true,
			save: true,
		},
	},
	[RbidosRequestStatuses.S_DOCS_SENT]: {
		slug: RbidosRequestStatuses.S_DOCS_SENT,
		name: 'Подготовка документов',
		description: `В настоящее время подготавливаются документы для регистрации бизнеса клиента. 
		Для проверки готовности нажмите "Обновить"`,
		isShowModalForPush: false,
		buttons: {
			push: true,
			typePush: TYPE_SUBMIT_FORM.UPDATE,
			titlePush: 'Обновить',
			pushIcon: 'refresh',
			rollback: true,
			save: true,
		},
	},
	[RbidosRequestStatuses.S_DOCS_GENERATED]: {
		slug: RbidosRequestStatuses.S_DOCS_GENERATED,
		name: 'Подготовка документов',
		description: `В настоящее время подготавливаются документы для регистрации бизнеса клиента. 
		Для проверки готовности нажмите "Обновить"`,
		isShowModalForPush: false,
		buttons: {
			push: true,
			typePush: TYPE_SUBMIT_FORM.UPDATE,
			titlePush: 'Обновить',
			pushIcon: 'refresh',
			rollback: true,
			save: true,
		},
	},
	[RbidosRequestStatuses.S_DOCS_LOADED]: {
		slug: RbidosRequestStatuses.S_DOCS_LOADED,
		name: 'Документы подготовлены',
		description: `После успешного формирования документов ознакомьтесь с ними на шаге "Сведения об организации" 
		(установите "галочку" ознакомления), а также укажите адрес подразделения Сбербанка в рамках 
		открытия счета на шаге "Расчетный счет в Сбербанке". Затем нажмите кнопку "Отправить заявку".`,
		isShowModalForPush: false,
		buttons: {
			push: true,
			typePush: TYPE_SUBMIT_FORM.PUSH,
			stepAfterPush: STEP_FORM.PAY_PRODUCT,
			titlePush: 'Отправить заявку',
			rollback: true,
			save: true,
		},
	},
	[RbidosRequestStatuses.S_EXECUTION]: {
		slug: RbidosRequestStatuses.S_EXECUTION,
		name: 'Заявка создана',
		description: `Поздравляем, заявка успешно создана!
		Теперь перейдите на шаг "Очная идентификация" и проведите очную идентификацию клиента.`,
		isShowModalForPush: false,
		buttons: {
			push: false,
			rollback: false,
			save: true,
			update: true,
		},
		buttons_ochka: {
			exitAccount: true,
			updateStatus: true,
			cancelSertificate: false,
			repeatIdentification: true,
		},
	},
	[RbidosRequestStatuses.S_CI_WAIT_PKCS10]: {
		slug: RbidosRequestStatuses.S_CI_WAIT_PKCS10,
		name: 'Ожидание получения запроса на сертификат',
		description: `Для продолжения процедуры прохождения очной идентификации клиенту в мобильном приложении 
		IDPoint необходимо: • Принять условия Лицензионного соглашения. 
		• Ознакомиться с руководством по безопасности. • Сгенерировать себе пароль. 
		Для проверки выполнения клиентом данных требований нажмите «Обновить». 
		Если требования выполнены, статус изменится на «Ожидание идентификации клиента».`,
		isShowModalForPush: false,
		buttons: {
			push: false,
			rollback: false,
			save: false,
			update: true,
		},
		buttons_ochka: {
			exitAccount: true,
			updateStatus: true,
			cancelSertificate: false,
			repeatIdentification: true,
		},
	},
	[RbidosRequestStatuses.S_CI_WAIT_CONSUMER_IDENTIFICATION]: {
		slug: RbidosRequestStatuses.S_CI_WAIT_CONSUMER_IDENTIFICATION,
		name: 'Ожидание идентификации клиента',
		description: `Вам требуется: • Провести очную идентификацию подписанта клиента.  • 
		Нажать на «Подтвердить идентификацию». Для получения обновленной информации по клиенту нажмите 
		на «Обновить».`,
		isShowModalForPush: false,
		buttons: {
			push: false,
			rollback: false,
			save: false,
			update: true,
		},
		buttons_ochka: {
			exitAccount: true,
			updateStatus: true,
			cancelSertificate: false,
			repeatIdentification: true,
		},
	},
	[RbidosRequestStatuses.S_CI_CERTIFICATE_ISSUE]: {
		slug: RbidosRequestStatuses.S_CI_CERTIFICATE_ISSUE,
		name: 'Выпуск сертификата',
		description:
			'В мобильном приложении IDPoint у Вашего клиента требуется выпустить сертификат электронной подписи',
		isShowModalForPush: false,
		buttons: {
			push: false,
			rollback: false,
			save: false,
			update: true,
		},
		buttons_ochka: {
			exitAccount: true,
			updateStatus: true,
			cancelSertificate: false,
			repeatIdentification: true,
		},
	},
	[RbidosRequestStatuses.S_CI_WAIT_CERTIFICATE_RECEIVE]: {
		slug: RbidosRequestStatuses.S_CI_WAIT_CERTIFICATE_RECEIVE,
		name: 'Ожидание ознакомления с сертификатом',
		description: undefined,
		isShowModalForPush: false,
		buttons: {
			push: false,
			rollback: false,
			save: false,
			update: true,
		},
		buttons_ochka: {
			exitAccount: true,
			updateStatus: true,
			cancelSertificate: false,
			repeatIdentification: true,
		},
	},
	[RbidosRequestStatuses.S_CI_COMPLETE]: {
		slug: RbidosRequestStatuses.S_CI_COMPLETE,
		name: 'Завершено',
		description: `Вашему клиенту в мобильном приложении IDPoint доступна квалифицированная электронная подпись 
		для подписания документов. Необходимо ознакомиться с пакетом документов и подписать их для отправки в ФНС.`,
		isShowModalForPush: false,
		buttons: {
			push: false,
			rollback: false,
			save: false,
			update: true,
		},
		buttons_ochka: {
			exitAccount: true,
			updateStatus: true,
			cancelSertificate: false,
			repeatIdentification: true,
		},
	},
	[RbidosRequestStatuses.S_CI_REJECTED]: {
		slug: RbidosRequestStatuses.S_CI_REJECTED,
		name: 'Отклонено',
		description: undefined,
		isShowModalForPush: false,
		buttons: {
			push: false,
			rollback: false,
			save: false,
		},
		buttons_ochka: {
			exitAccount: true,
			updateStatus: true,
			cancelSertificate: false,
			repeatIdentification: true,
		},
	},
	[RbidosRequestStatuses.S_CI_ERROR]: {
		slug: RbidosRequestStatuses.S_CI_ERROR,
		name: 'Ошибка',
		description: undefined,
		isShowModalForPush: false,
		buttons: {
			push: false,
			rollback: false,
			save: false,
		},
		buttons_ochka: {
			exitAccount: true,
			updateStatus: true,
			cancelSertificate: false,
			repeatIdentification: true,
		},
	},
	[RbidosRequestStatuses.S_CI_CANCELED]: {
		slug: RbidosRequestStatuses.S_CI_CANCELED,
		name: 'Отменено',
		description: undefined,
		isShowModalForPush: false,
		buttons: {
			push: false,
			rollback: false,
			save: false,
		},
		buttons_ochka: {
			exitAccount: true,
			updateStatus: true,
			cancelSertificate: false,
			repeatIdentification: true,
		},
	},
	[RbidosRequestStatuses.S_CI_WAIT_SCAN_UPLOAD]: {
		slug: RbidosRequestStatuses.S_CI_WAIT_SCAN_UPLOAD,
		name: 'Ожидание загрузки скан-копий',
		description: `Вам требуется: • Распечатать сертификат в двух экземплярах. • Подписать сертификаты у клиента. • 
		Подписать сертификаты лично. • Загрузить все требуемые документы в соответствующие поля и нажать кнопку 
		«Подтвердить данные». Один экземпляр сертификата передать клиенту. Второй экземпляр оставить у себя и 
		передать в течение 1 месяца в адрес: Акционерное общество «ИнфоТеКС Интернет Траст». 
		Для получения обновленной информации по клиенту нажмите на «Обновить».`,
		isShowModalForPush: false,
		buttons: {
			push: false,
			rollback: false,
			save: false,
			update: true,
		},
		buttons_ochka: {
			exitAccount: true,
			updateStatus: true,
			cancelSertificate: false,
			repeatIdentification: true,
		},
	},
	[RbidosRequestStatuses.S_RBIDOS_FNS_REGISTRATION_COMPLETED_NO_DOS]: {
		slug: RbidosRequestStatuses.S_RBIDOS_FNS_REGISTRATION_COMPLETED_NO_DOS,
		name: 'Бизнес зарегистрирован',
		description: `Бизнес зарегистрирован! Клиенту необходимо сформировать подпись юридического лица в мобильном 
		приложении ID Point и подписать документы на открытие счета.`,
		isShowModalForPush: false,
		buttons: {
			push: false,
			rollback: false,
			save: true,
		},
	},
	[RbidosRequestStatuses.S_RBIDOS_OPEN_ACCOUNT_REJECTED]: {
		slug: RbidosRequestStatuses.S_RBIDOS_OPEN_ACCOUNT_REJECTED,
		name: 'Отказано в открытии счета',
		description: `К сожалению, клиенту отказано в открытии счета.`,
		buttons: {
			push: false,
			rollback: false,
			save: false,
		},
	},
	[RbidosRequestStatuses.S_RBIDOS_VSP_NO_DOS_ACCOUNT_OPENED]: {
		slug: RbidosRequestStatuses.S_RBIDOS_VSP_NO_DOS_ACCOUNT_OPENED,
		name: 'Счёт открыт в офисе Сбера',
		description: `Вашему клиенту открыт счёт в офисе Сбера`,
		isShowModalForPush: false,
		buttons: {
			push: false,
			rollback: false,
			save: false,
		},
	},
	[RbidosRequestStatuses.S_RBIDOS_CANCELED_NO_FNS]: {
		slug: RbidosRequestStatuses.S_RBIDOS_CANCELED_NO_FNS,
		name: 'Архив (не отправлена в ФНС)',
		description: 'Заявка отправлена в архив по истечении срока.',
		isShowModalForPush: false,
		buttons: {
			push: false,
			rollback: false,
			save: false,
		},
	},
	[RbidosRequestStatuses.S_RBIDOS_FNS_PACKAGE_SEND]: {
		slug: RbidosRequestStatuses.S_RBIDOS_FNS_PACKAGE_SEND,
		name: 'Документы отправлены в ИФНС',
		description: 'Документы успешно отправлены в ИФНС на рассмотрение!',
		isShowModalForPush: false,
		buttons: {
			push: false,
			rollback: false,
			save: false,
			update: true,
		},
	},
	[RbidosRequestStatuses.S_RBIDOS_FNS_REGISTRATION_REJECTED]: {
		slug: RbidosRequestStatuses.S_RBIDOS_FNS_REGISTRATION_REJECTED,
		name: 'Отказ ФНС в регистрации бизнеса',
		description: `К сожалению, клиенту отказано в регистрации бизнеса.`,
		isShowModalForPush: false,
		buttons: {
			push: false,
			rollback: false,
			save: false,
		},
	},
	[RbidosRequestStatuses.S_RBIDOS_GOT_FNS_RESULT]: {
		slug: RbidosRequestStatuses.S_RBIDOS_GOT_FNS_RESULT,
		name: 'Бизнес зарегистрирован',
		description: `Бизнес зарегистрирован! Клиенту необходимо сформировать подпись юридического лица в мобильном 
		приложении ID Point и подписать документы на открытие счета.`,
		isShowModalForPush: false,
		buttons: {
			push: false,
			rollback: false,
			save: false,
		},
	},
	[RbidosRequestStatuses.S_RBIDOS_FNS_RECEIPT_RECEIVED]: {
		slug: RbidosRequestStatuses.S_RBIDOS_FNS_RECEIPT_RECEIVED,
		name: 'Документы приняты ФНС',
		description: `Документы приняты ФНС, направлена расписка о принятии. Предполагаемая дата регистрации: xx.xx.xxxx`,
		isShowModalForPush: false,
		buttons: {
			push: false,
			rollback: false,
			save: false,
			update: true,
		},
	},
	[RbidosRequestStatuses.S_RBIDOS_COMPLIANCE_UL_CHECK_FAIL]: {
		slug: RbidosRequestStatuses.S_RBIDOS_COMPLIANCE_UL_CHECK_FAIL,
		name: 'Отказ (по проверке банка)',
		description: `Клиент не прошел проверку Банка`,
		isShowModalForPush: false,
		buttons: {
			push: false,
			rollback: false,
			save: false,
		},
	},
	[RbidosRequestStatuses.S_DELETED]: {
		slug: RbidosRequestStatuses.S_DELETED,
		name: 'Заявка удалена',
		description: '',
		isShowModalForPush: false,
		buttons: {
			push: false,
			rollback: false,
			save: false,
		},
	},
	[RbidosRequestStatuses.S_RBIDOS_CA_VALIDATION_REJECTED]: {
		slug: RbidosRequestStatuses.S_RBIDOS_CA_VALIDATION_REJECTED,
		name: 'Отказ (по проверке СМЭВ)',
		description: ``,
		isShowModalForPush: false,
		buttons: {
			push: false,
			rollback: false,
			save: false,
		},
	},
	[RbidosRequestStatuses.S_RBIDOS_CA_VALIDATION_COMPLETE]: {
		slug: RbidosRequestStatuses.S_RBIDOS_CA_VALIDATION_COMPLETE,
		name: 'Заявка создана',
		description: '',
		isShowModalForPush: false,
		buttons: {
			push: false,
			rollback: false,
			save: false,
			update: true,
		},
	},
	[RbidosRequestStatuses.S_DIVISION_SENT]: {
		slug: RbidosRequestStatuses.S_DIVISION_SENT,
		name: 'Формирование заявки',
		description: `Заявка на клиента полностью заполнена! Подождите немного, мы обрабатываем данные.`,
		buttons: {
			push: false,
			rollback: false,
			save: false,
		},
	},
	[RbidosRequestStatuses.S_TARIFF_SENT]: {
		slug: RbidosRequestStatuses.S_TARIFF_SENT,
		name: 'Формирование заявки',
		description: `Заявка на клиента полностью заполнена! Подождите немного, мы обрабатываем данные.`,
		buttons: {
			push: false,
			rollback: false,
			save: false,
		},
	},
	[RbidosRequestStatuses.S_RBIDOS_ACCOUNT_OPENED]: {
		slug: RbidosRequestStatuses.S_RBIDOS_ACCOUNT_OPENED,
		name: 'Счет открыт',
		description: `Ура, Вашему клиенту открыт счет!`,
		buttons: {
			push: false,
			rollback: false,
			save: false,
		},
	},
	[RbidosRequestStatuses.S_RBIDOS_KEP_UL_REQUESTED]: {
		slug: RbidosRequestStatuses.S_RBIDOS_KEP_UL_REQUESTED,
		name: 'Выпуск подписи ЮЛ',
		description: `Клиентом в мобильном приложении ID Point запрошен выпуск подписи юридического лица`,
		buttons: {
			push: false,
			rollback: false,
			save: false,
			update: true,
		},
	},
	[RbidosRequestStatuses.S_RBIDOS_DOS_DOC_SIGN_REQUESTED]: {
		slug: RbidosRequestStatuses.S_RBIDOS_DOS_DOC_SIGN_REQUESTED,
		name: 'Ожидание подписания документов (ДОС)',
		description: `Клиенту в мобильном приложении ID Point необходимо подписать документы на открытие счета.`,
		buttons: {
			push: false,
			rollback: false,
			save: false,
			update: true,
		},
	},
	[RbidosRequestStatuses.S_RBIDOS_KEP_UL_ERROR]: {
		slug: RbidosRequestStatuses.S_RBIDOS_KEP_UL_ERROR,
		name: 'Ошибка при выпуске КЭП ЮЛ',
		description: `Произошла ошибка при выпуске КЭП ЮЛ, обратитесь в клиентскую поддержку.`,
		buttons: {
			push: false,
			rollback: false,
			save: false,
		},
	},
	[RbidosRequestStatuses.S_RBIDOS_ORGANIZATION_IDENTIFICATION_ERROR]: {
		slug: RbidosRequestStatuses.S_RBIDOS_ORGANIZATION_IDENTIFICATION_ERROR,
		name: 'Ошибка идентификации компании',
		description: `Произошла ошибка идентификации компании, обратитесь в клиентскую поддержку.`,
		buttons: {
			push: false,
			rollback: false,
			save: false,
		},
	},
	[RbidosRequestStatuses.S_RBIDOS_ORGANIZATION_IDENTIFICATION_REJECTED]: {
		slug: RbidosRequestStatuses.S_RBIDOS_ORGANIZATION_IDENTIFICATION_REJECTED,
		name: 'Отказ (по идентификации компании)',
		description: `Произошла ошибка в открытии счёта. 
		Предложите клиенту обратиться в офис Сбера с документами для открытия счёта.`,
		buttons: {
			push: false,
			rollback: false,
			save: false,
		},
	},
	[RbidosRequestStatuses.S_KEP_UL_KORUS_REQUEST_CREATED_SUCCESS]: {
		slug: RbidosRequestStatuses.S_KEP_UL_KORUS_REQUEST_CREATED_SUCCESS,
		name: 'Запрос на выпуск КЭП ЮЛ',
		description: `Процесс на стороне клиента: необходимо войти в мобильное приложение IDPoint и ознакомиться 
		с заявлением на выпуск КЭП ЮЛ. Если клиент это сделал ранее, обратитесь в клиентскую поддержку.`,
		buttons: {
			push: false,
			rollback: false,
			save: false,
			update: true,
		},
	},
	[RbidosRequestStatuses.S_KEP_UL_KORUS_REQUEST_CREATION_ERROR]: {
		slug: RbidosRequestStatuses.S_KEP_UL_KORUS_REQUEST_CREATION_ERROR,
		name: 'Ошибка выпуска  КЭП ЮЛ',
		description: `Внимание! Произошла ошибка при обработке запроса на выпуск КЭП ЮЛ, обратитесь в 
		клиентскую поддержку.`,
		buttons: {
			push: false,
			rollback: false,
			save: false,
		},
	},
	[RbidosRequestStatuses.S_KEP_UL_WORKFLOW_SUCCESS_CREATED]: {
		slug: RbidosRequestStatuses.S_KEP_UL_WORKFLOW_SUCCESS_CREATED,
		name: 'Ожидание клиента (выпуск КЭП ЮЛ в IDPoint)',
		description: `Процесс на стороне клиента: необходимо войти в мобильное приложение IDPoint и отправить запрос 
		на выпуск сертификата. Если клиент это сделал ранее, обратитесь в клиентскую поддержку.`,
		buttons: {
			push: false,
			rollback: false,
			save: false,
			update: true,
		},
	},
	[RbidosRequestStatuses.S_KEP_UL_WORKFLOW_ERROR_CREATE]: {
		slug: RbidosRequestStatuses.S_KEP_UL_WORKFLOW_ERROR_CREATE,
		name: 'Ошибка выпуска  КЭП ЮЛ',
		description: `Внимание! Произошла ошибка при обработке запроса на выпуск КЭП ЮЛ, обратитесь в 
		клиентскую поддержку.`,
		buttons: {
			push: false,
			rollback: false,
			save: false,
		},
	},
	[RbidosRequestStatuses.S_KEP_UL_STATEMENT_RECEIVED_SUCCESS]: {
		slug: RbidosRequestStatuses.S_KEP_UL_STATEMENT_RECEIVED_SUCCESS,
		name: 'Запрос на выпуск КЭП ЮЛ',
		description: `Процесс на стороне клиента: необходимо войти в мобильное приложение IDPoint и ознакомиться 
		с заявлением на выпуск КЭП ЮЛ. Если клиент это сделал ранее, обратитесь в клиентскую поддержку.`,
		buttons: {
			push: false,
			rollback: false,
			save: false,
			update: true,
		},
	},
	[RbidosRequestStatuses.S_KEP_UL_REQUEST_SENT_TO_VERIFICATION_SUCCESS]: {
		slug: RbidosRequestStatuses.S_KEP_UL_REQUEST_SENT_TO_VERIFICATION_SUCCESS,
		name: 'Запрос на выпуск КЭП ЮЛ',
		description: `Процесс на стороне клиента: необходимо войти в мобильное приложение IDPoint и ознакомиться 
		с заявлением на выпуск КЭП ЮЛ. Если клиент это сделал ранее, обратитесь в клиентскую поддержку.`,
		buttons: {
			push: false,
			rollback: false,
			save: false,
			update: true,
		},
	},
	[RbidosRequestStatuses.S_KEP_UL_REQUEST_ERROR_SEND_TO_VERIFICATION]: {
		slug: RbidosRequestStatuses.S_KEP_UL_REQUEST_ERROR_SEND_TO_VERIFICATION,
		name: 'Ошибка выпуска  КЭП ЮЛ',
		description: `Внимание! Произошла ошибка при обработке запроса на выпуск КЭП ЮЛ, обратитесь в 
		клиентскую поддержку.`,
		buttons: {
			push: false,
			rollback: false,
			save: false,
		},
	},
	[RbidosRequestStatuses.S_KEP_UL_APPROVED]: {
		slug: RbidosRequestStatuses.S_KEP_UL_APPROVED,
		name: 'Ожидание клиента (подписание документов в IDPoint)',
		description: `Процесс на стороне клиента: необходимо войти в мобильное приложение IDPoint и подписать документы 
		на выпуск электронной подписи. Если клиент это сделал ранее, обратитесь в клиентскую поддержку.`,
		buttons: {
			push: false,
			rollback: false,
			save: false,
			update: true,
		},
	},
	[RbidosRequestStatuses.S_KEP_UL_REQUEST_REJECTED_BY_OPERATOR]: {
		slug: RbidosRequestStatuses.S_KEP_UL_REQUEST_REJECTED_BY_OPERATOR,
		name: 'Выпуск КЭП ЮЛ отклонен УЦ',
		description: `Внимание! К сожалению, выпуск КЭП ЮЛ отклонен, обратитесь в клиентскую поддержку.`,
		buttons: {
			push: false,
			rollback: false,
			save: false,
		},
	},
	[RbidosRequestStatuses.S_KEP_UL_REQUEST_ERROR_GENERATION_CERTIFICATE]: {
		slug: RbidosRequestStatuses.S_KEP_UL_REQUEST_ERROR_GENERATION_CERTIFICATE,
		name: 'Ошибка выпуска  КЭП ЮЛ',
		description: `Внимание! Произошла ошибка при обработке запроса на выпуск КЭП ЮЛ, обратитесь в 
		клиентскую поддержку.`,
		buttons: {
			push: false,
			rollback: false,
			save: false,
		},
	},
	[RbidosRequestStatuses.S_KEP_UL_REQUEST_UNEXPECTED_ERROR]: {
		slug: RbidosRequestStatuses.S_KEP_UL_REQUEST_UNEXPECTED_ERROR,
		name: 'Ошибка выпуска  КЭП ЮЛ',
		description: `Внимание! Произошла ошибка при обработке запроса на выпуск КЭП ЮЛ, обратитесь в 
		клиентскую поддержку.`,
		buttons: {
			push: false,
			rollback: false,
			save: false,
		},
	},
	[RbidosRequestStatuses.S_KEP_UL_DOCUMENTS_SIGNED_SUCCESS]: {
		slug: RbidosRequestStatuses.S_KEP_UL_DOCUMENTS_SIGNED_SUCCESS,
		name: 'Запрос на подписание документов',
		description: `Выполняется запрос на подписание документов. Ожидайте завершения.`,
		buttons: {
			push: false,
			rollback: false,
			save: false,
			update: true,
		},
	},
	[RbidosRequestStatuses.S_KEP_UL_DOCUMENTS_SIGNING_ERROR]: {
		slug: RbidosRequestStatuses.S_KEP_UL_DOCUMENTS_SIGNING_ERROR,
		name: 'Ошибка при подписании документов',
		description: `Внимание! Произошла ошибка при подписании документов для выпуска КЭП, обратитесь в 
		клиентскую поддержку.`,
		buttons: {
			push: false,
			rollback: false,
			save: false,
		},
	},
	[RbidosRequestStatuses.S_KEP_UL_SIGNS_SENT_SUCCESS]: {
		slug: RbidosRequestStatuses.S_KEP_UL_SIGNS_SENT_SUCCESS,
		name: 'Запрос на подписание документов',
		description: `Выполняется запрос на подписание документов. Ожидайте завершения.`,
		buttons: {
			push: false,
			rollback: false,
			save: false,
			update: true,
		},
	},
	[RbidosRequestStatuses.S_KEP_UL_SIGNS_SENDING_ERROR]: {
		slug: RbidosRequestStatuses.S_KEP_UL_SIGNS_SENDING_ERROR,
		name: 'Ошибка при подписании документов',
		description: `Внимание! Произошла ошибка при подписании документов для выпуска КЭП, обратитесь в 
		клиентскую поддержку.`,
		buttons: {
			push: false,
			rollback: false,
			save: false,
		},
	},
	[RbidosRequestStatuses.S_KEP_UL_REQUEST_PEM_SENT_SUCCESS]: {
		slug: RbidosRequestStatuses.S_KEP_UL_REQUEST_PEM_SENT_SUCCESS,
		name: 'Ожидание клиента (ознакомление с сертификатом в IDPoint)',
		description: `Процесс на стороне клиента: необходимо войти в мобильное приложение IDPoint и ознакомиться 
		с сертификатом. Если клиент это сделал ранее, обратитесь в клиентскую поддержку`,
		buttons: {
			push: false,
			rollback: false,
			save: false,
			update: true,
		},
	},
	[RbidosRequestStatuses.S_KEP_UL_REQUEST_ERROR_SENDING_PEM]: {
		slug: RbidosRequestStatuses.S_KEP_UL_REQUEST_ERROR_SENDING_PEM,
		name: 'Ошибка при подписании документов',
		description: `Внимание! Произошла ошибка при подписании документов для выпуска КЭП, обратитесь в 
		клиентскую поддержку.`,
		buttons: {
			push: false,
			rollback: false,
			save: false,
		},
	},
	[RbidosRequestStatuses.S_RBIDOS_RESERVE_ACCOUNT_COMPLETED]: {
		slug: RbidosRequestStatuses.S_RBIDOS_RESERVE_ACCOUNT_COMPLETED,
		name: 'Счет зарезервирован',
		description: `Сообщите клиенту: "Счёт зарезервирован, реквизиты направлены клиенту на e-mail и в СМС. 
		Для открытия счета выездной клиентский менеджер свяжется с клиентом в ближайшее время"`,
		buttons: {
			push: false,
			rollback: false,
			save: false,
		},
	},
	[RbidosRequestStatuses.S_RBIDOS_RESERVE_ACCOUNT_REJECTED]: {
		slug: RbidosRequestStatuses.S_RBIDOS_RESERVE_ACCOUNT_REJECTED,
		name: 'Отказано в резервировании счета',
		description: `Сообщите клиенту: "к сожалению, услуга резервирования счета недоступна для Вашей организации/ИП. 
		Открыть счет Вы можете в любом офисе Банка, обслуживающем юридических лиц, или в личном кабинете Сбербанк 
		Бизнес Онлайн."`,
		buttons: {
			push: false,
			rollback: false,
			save: false,
		},
	},
	[RbidosRequestStatuses.S_RBIDOS_PEP_DOS_DOC_GENERATION_ERROR]: {
		slug: RbidosRequestStatuses.S_RBIDOS_PEP_DOS_DOC_GENERATION_ERROR,
		name: 'Ошибка формирования документов',
		description: `Произошла ошибка при формировании документов, обратитесь в клиентскую поддержку.`,
		buttons: {
			push: false,
			rollback: false,
			save: false,
		},
	},
	[RbidosRequestStatuses.S_RBIDOS_PEP_DOS_DOC_SIGN_REQUEST_ACCEPTED]: {
		slug: RbidosRequestStatuses.S_RBIDOS_PEP_DOS_DOC_SIGN_REQUEST_ACCEPTED,
		name: 'Ожидание клиента (отправлено уведомление в СБОЛ)',
		description: `Клиенту отправлено уведомление в СБОЛ. По умолчанию используется пуш-уведомление (резервно - смс).
		Требуется перейти по ссылке для подписания документов на открытие счета.`,
		buttons: {
			push: false,
			rollback: false,
			save: false,
			update: true,
		},
	},
	[RbidosRequestStatuses.S_RBIDOS_PEP_DOS_DOC_SIGN_REQUESTED]: {
		slug: RbidosRequestStatuses.S_RBIDOS_PEP_DOS_DOC_SIGN_REQUESTED,
		name: 'Ожидание подписания документов (СБОЛ)',
		description: `Клиент перешел по отправленному уведомлению СБОЛ. Требуется подписание документов в приложении.`,
		buttons: {
			push: false,
			rollback: false,
			save: false,
			update: true,
		},
	},
	[RbidosRequestStatuses.S_RBIDOS_PEP_DOS_DOC_SIGNED]: {
		slug: RbidosRequestStatuses.S_RBIDOS_PEP_DOS_DOC_SIGNED,
		name: 'Ожидание открытия счёта',
		description: `Клиент успешно подписал документы в СБОЛ. Выполняется процедура открытия счёта.
		 Обычно это занимает несколько минут.`,
		buttons: {
			push: false,
			rollback: false,
			save: false,
			update: true,
		},
	},
	[RbidosRequestStatuses.S_RBIDOS_PEP_OPEN_ACCOUNT_ERROR]: {
		slug: RbidosRequestStatuses.S_RBIDOS_PEP_OPEN_ACCOUNT_ERROR,
		name: 'Техническая ошибка',
		description: `Техническая ошибка при открытии счета. Мы работаем с такими ошибками и перезапускаем процесс. 
		Если ситуация не изменилась в течение нескольких часов - обратитесь в клиентскую поддержку.`,
		buttons: {
			push: false,
			rollback: false,
			save: false,
		},
	},
	[RbidosRequestStatuses.S_SBOL_VERIFICATION_FAILED]: {
		slug: RbidosRequestStatuses.S_SBOL_VERIFICATION_FAILED,
		name: 'Ошибка проверки в приложении Сбера',
		buttons: {
			push: false,
			rollback: true,
			save: false,
		},
	},
}

export const outManagerAvailableStatuses = [
	RbidosRequestStatuses.S_RBIDOS_CA_VALIDATION_COMPLETE,
	RbidosRequestStatuses.S_CI_WAIT_PKCS10,
	RbidosRequestStatuses.S_CI_WAIT_CONSUMER_IDENTIFICATION,
	RbidosRequestStatuses.S_CI_CERTIFICATE_ISSUE,
	RbidosRequestStatuses.S_CI_WAIT_CERTIFICATE_RECEIVE,
	RbidosRequestStatuses.S_CI_COMPLETE,
	RbidosRequestStatuses.S_CI_REJECTED,
	RbidosRequestStatuses.S_CI_ERROR,
	RbidosRequestStatuses.S_CI_CANCELED,
	RbidosRequestStatuses.S_CI_WAIT_SCAN_UPLOAD,
	RbidosRequestStatuses.S_RBIDOS_GOT_FNS_RESULT,
	RbidosRequestStatuses.S_RBIDOS_FNS_REGISTRATION_COMPLETED_NO_DOS,
	RbidosRequestStatuses.S_RBIDOS_CANCELED_NO_FNS,
	RbidosRequestStatuses.S_RBIDOS_FNS_PACKAGE_SEND,
	RbidosRequestStatuses.S_RBIDOS_FNS_REGISTRATION_REJECTED,
	RbidosRequestStatuses.S_RBIDOS_FNS_RECEIPT_RECEIVED,
]
